'use client'

/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-floating-promises */
import CarDetailsWidget from '@acko-tech/building-blocks.ui.car-details-widget'
import axios from 'axios'
import { useState } from 'react'

import { r2d2, cookie } from '@components/Ackodrive/common/globals'
import IllogicalFlowMessage from './IllogicalFlowMessage'

const NEW_CAR_REDIRECTION_URL =
  '/lp/new-comprehensive/new-car/details/?utm_source=organic&utm_medium=seo&utm_campaign=product-widget'

const R2D2_URL = `${process.env.NEXT_PUBLIC_SITE_URL}/api/r2d2/`

const CarWidget = ({ widgetOptions, reqCookie, isMobileDevice = false, okind }) => {
  const [isFetching, setIsFetching] = useState(false)
  const [showIllogicalFlowModal, setShowIllogicalFlowModal] = useState(false)

  const isLoggedIn = typeof reqCookie === 'string' && reqCookie.includes('user_id=')

  const onBlurCarInput = (isValid, carNumber) => {
    if (isValid) {
      r2d2({
        ekind: 'registration_number_entered',
        okind,
        oid: cookie('trackerid') || '',
        edata: {
          product_state: 'Marketing Landing Pages',
          screen: 'registration_number_screen',
          url: window.location.href,
          registration_number: carNumber,
        },
      })
    } else {
      r2d2({
        ekind: 'invalid_registration_number_entered',
        okind,
        oid: cookie('trackerid') || '',
        edata: {
          product_state: 'Marketing Landing Pages',
          screen: 'registration_number_screen',
          url: window.location.href,
          registration_number: carNumber,
        },
      })
    }
  }

  const onBlurMobileInput = (isValid, _carNumber, mobileNumber) => {
    if (isValid) {
      r2d2({
        ekind: 'mobile_number_entered',
        okind,
        oid: cookie('trackerid') || '',
        edata: {
          product_state: 'Marketing Landing Pages',
          screen: 'registration_number_screen',
          url: window.location.href,
          mobile_number: mobileNumber,
        },
      })
    } else {
      r2d2({
        ekind: 'invalid_mobile_number_entered',
        okind,
        oid: cookie('trackerid') || '',
        edata: {
          product_state: 'Marketing Landing Pages',
          screen: 'registration_number_screen',
          url: window.location.href,
          mobile_number: mobileNumber,
        },
      })
    }
  }

  const getProposal = (regNo, mobNo) => {
    setIsFetching(true)
    const apiUrl = '/api/seo/consumerService/proposal'

    const goToProposal = pid => (window.location.href = `/n/car/nsr?proposal_id=${pid}`)

    axios
      .post<{ proposal_id: string }>(
        apiUrl,
        { registration_number: regNo, mobile_no: mobNo },
        { headers: { 'X-Landing-Path': '/' } }
      )
      .then(res => {
        res.data.proposal_id && goToProposal(res.data.proposal_id)
        setIsFetching(false)
      })
      .catch(error => {
        const { response } = error
        if (response.status === 403) {
          if (isLoggedIn) {
            window.location.href = process.env.NEXT_PUBLIC_MYACCOUNT_PATH || ''
          } else {
            // setIllogicalFlowData(response.data);
            setShowIllogicalFlowModal(true)
          }
        } else {
          console.log(`[CAR WIDGET] error : ${error.message}`)
        }
        setIsFetching(false)
      })
  }

  const handleSubmit = (isValid, carNumber, mobileNumber) => {
    if (isValid) {
      setTimeout(() => {
        setIsFetching(true)
      }, 10)

      r2d2({
        ekind: 'insure_now_cta_clicked',
        okind,
        oid: cookie('trackerid') || '',
        edata: {
          product_state: 'Marketing Landing Pages',
          screen: 'registration_number_screen',
          url: window.location.href,
          registration_number: carNumber,
          mobile_number: mobileNumber,
        },
      })?.finally(() => getProposal(carNumber, mobileNumber))
    } else {
      r2d2({
        ekind: 'error_on_insure_now_cta_clicked',
        okind,
        oid: cookie('trackerid') || '',
        edata: {
          product_state: 'Marketing Landing Pages',
          screen: 'registration_number_screen',
          url: window.location.href,
          registration_number: carNumber,
          mobile_number: mobileNumber,
        },
      })
    }
  }

  return (
    <>
      <CarDetailsWidget
        {...widgetOptions}
        isDesktop={!isMobileDevice}
        onSubmit={handleSubmit}
        isFetching={isFetching}
        regNumberInput={{ onBlur: onBlurCarInput, onChange: () => null }}
        mobileNumberInput={{
          onBlur: onBlurMobileInput,
          onChange: () => null,
        }}
        newCarRedirectionLink={NEW_CAR_REDIRECTION_URL}
        requestUrl={R2D2_URL}
        okind={okind}
      />

      <IllogicalFlowMessage show={showIllogicalFlowModal} isLoggedIn={isLoggedIn} />
    </>
  )
}

export default CarWidget
